import React from "react";
import EmployeeDocumentsPage from "./pages/EmployeeDocumentsPage";

export const employeeDocumentRoutes = [
  { path: "/employee-documents", element: <EmployeeDocumentsPage /> },
];
